var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._g(_vm._b({staticClass:"material-design-icon drone-icon",attrs:{"aria-hidden":_vm.decorative,"aria-label":_vm.title,"role":"img"}},'span',_vm.$attrs,false),_vm.$listeners),[_c('DroneSvg',{staticClass:"material-design-icon__svg",attrs:{"fill":_vm.fillColor,"width":_vm.size,"height":_vm.size}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }